<template>
    <div>
        <div class="extended_field extended_field-wide" v-for="(field, field_index) in d" v-bind:key="field_index">

            <label class="info" v-on:click="help = help == field.infotext ? false : field.infotext" v-if="field.infotext && field.type !== 'Hidden'">?</label>

            <label v-html="$root.t(field.name)">
            </label>

            <transition name="drop">
                <div  class="infotext" v-if="help == field.infotext && help !== false">
                    <p v-html="$root.t(field.infotext)" ></p>
                </div>
            </transition>
            
            
            <input v-model="form_data[field.id].Content" v-if="field.type === 'text'" type="text" :name="`wf[${field.id}]`">

            <template v-if="field.type === 'date'">
                <div class="select-wrapper">
                    <select v-model="form_data[`${field.id}_genauigkeit`].Content[0]" v-on:change="form_data[field.id].Content = ''">
                        <option :selected="form_data[`${field.id}_genauigkeit`].Content[0]==0?'selected':'false'"  value="0">dd.mm.YYYY</option>
                        <option :selected="form_data[`${field.id}_genauigkeit`].Content[0]==1?'selected':'false'"  value="1">YYYY</option>
                        <option :selected="form_data[`${field.id}_genauigkeit`].Content[0]==-1?'selected':'false'" value="-1">{{$root.t('option:disabled')}}</option>
                    </select>
                </div>
                <input v-model="form_data[field.id].Content" :placeholder="form_data[`${field.id}_genauigkeit`].Content[0]==0?'dd.mm.yyyy':form_data[`${field.id}_genauigkeit`].Content[0]==1?'yyyy':$root.t('option:disabled')" type="text" :name="`wf[${field.id}]`">
            </template>
            
            <template v-if="field.type === 'file'">
                <input v-on:change="onFileChange($event, field.id)" :ref="`field_${field.id}`" type="file" :name="`wf[${field.id}]`">
                <input v-model="form_data[field.id].Content[0].Captions" :placeholder="$root.t(`${field.name}:placeholder`)" type="text" :name="`wf[${field.id}]`">
                <div class="upload-preview" v-if="form_data[field.id].Content && form_data[field.id].Content[0] && form_data[field.id].Content[0].Files" :style="{'background-image': `url(${form_data[field.id].Content[0].Files.Resized[0]})`}">
                    <a v-on:click="form_data[field.id].Content = [{Captions:'',Clear:true}]" class="tag remove"></a>
                </div>
            </template>
            <table class="table table-array" v-if="field.type === 'array'">
                <thead v-if="form_data[field.id].Content && form_data[field.id].Content.length > 0">
                    <td v-for="head in field.value" v-html="head"></td>
                    <td></td>
                </thead>
                <tr v-for="(row, rowkey) in form_data[field.id].Content">
                    <td v-for="(col, colkey) in row">
                        <input v-model="form_data[field.id].Content[rowkey][colkey]" type="text" :name="`wf[${field.id}][${rowkey}][${colkey}]`">
                    </td>
                    <td>
                        <a v-on:click="remove(form_data[field.id].Content, rowkey)" class="tag remove"></a>
                    </td>
                </tr>
                <tr>
                    <td :colspan="field.value.length">
                        <span v-if="!form_data[field.id].Content || form_data[field.id].Content.length == 0" v-html="$root.t('table:addrow')"></span>
                    </td>
                    <td>
                        <a v-on:click="add(form_data[field.id].Content, field.value.length)" class="tag add"></a>
                    </td>
                </tr>
            </table>

            <table class="table table-hash" v-if="field.type === 'hash'">
                <tr v-for="(row, rowkey) in field.value" v-if="form_data[field.id].Content[rowkey] && form_data[field.id].Content[rowkey][1] == row">
                    <td v-html="row"></td>
                    <td>
                        <input v-model="form_data[field.id].Content[rowkey][1]" type="hidden" :name="`wf[${field.id}][${rowkey}][1]`">
                        <input v-model="form_data[field.id].Content[rowkey][0]" :placeholder="$root.t(`profile:placeholder:${row}`)" type="text" :name="`wf[${field.id}][${rowkey}][0]`">
                    </td>
                </tr>
            </table>

            <table class="table table-hash" v-if="field.type === 'integration'">
                <tr v-for="(row, rowkey) in field.value">
                    <td v-html="row.Data.name.Content[$root.language]"></td>
                    <td class="inline">
                        <a class="decorated" :href="row.Data.url.Content.split(/\[:id\]/)[0]" target="_blank">{{row.Data.url.Content.split(/\[:id\]/)[0]}}</a>
                        <the-mask v-if="row.Data.input.Content[1]" :mask="row.Data.input.Content[0]" :tokens="row.Data.input.Content[1]" 
                        v-model="form_data[field.id].Content[rowkey][0]" 
                        :placeholder="$root.t(`profile:placeholder:service:${row.Contribution.Name}`)" 
                        type="text">
                        </the-mask>
                        <the-mask v-else :mask="row.Data.input.Content[0]"
                        v-model="form_data[field.id].Content[rowkey][0]" 
                        :placeholder="$root.t(`profile:placeholder:service:${row.Contribution.Name}`)" 
                        class="inline"
                        type="text">
                        </the-mask>
                        <a v-if="row.Data.url.Content.split(/\[:id\]/)[1]" class="decorated" :href="row.Data.url.Content.split(/\[:id\]/)[0]" target="_blank">{{row.Data.url.Content.split(/\[:id\]/)[1]}}</a>
                    </td>
                </tr>
            </table>

            <textarea v-model="form_data[field.id].Content" v-if="field.type === 'textarea'" type="text" :name="`wf[${field.id}]`"></textarea>

            <div class="select-wrapper" v-if="field.type === 'select'">
                <select v-model="form_data[field.id].Content[0]" :name="`wf[${field.id}]`">
                    <option 
                        v-for="(field_option, field_optkey) in field.value" 
                        v-bind:key="field_optkey" 
                        v-html="field_option.translation ? field_option.translation[$root.language] : field_option" 
                        :value="field_option.id ? field_option.id : field_optkey"
                        :selected="field_option.id ? field_option.id : field_optkey==form_data[field.id].Content?'selected':'false'"
                    />
                </select>
            </div>

            <div class="select-wrapper select-wrapper-multiple" v-if="field.type === 'select_multiple'">
                <select v-model="form_data[field.id].Content" :name="`wf[${field.id}]`" multiple>
                    <option 
                        v-for="(field_option, field_optkey) in field.value" 
                        v-bind:key="field_optkey" 
                        v-html="field_option.translation ? field_option.translation[$root.language] : field_option" 
                        :value="field_option.id ? field_option.id : field_optkey"
                        :selected="form_data[field.id].Content[field_option.id ? field_option.id : field_optkey]?'selected':'false'"
                    />
                </select>
            </div>

            <div class="autoselect" v-if="field.type === 'gnd'">
                <p  v-html="$root.t('profile:gnd:infotext')"></p>
                <div class="autoselect-ajax">
                    <input type="text" style="position: relative;" autocomplete="off" v-model="field.input" class="autoselect-left" :placeholder="$root.t('profile:gnd:placeholder')" v-on:keyup="autocomplete_gnd(field, $event)">
                    <input type="text" style="position: relative;" autocomplete="off" class="autoselect-right" v-model="form_data[field.id].Content">

                    <div class="autoselect-ajax-scroll" v-if="field.value.length > 0 && field.input != ''">
                        <a
                            v-for="field_option in field.value" 
                            :key="field_option.id" 
                            v-on:click="form_data[field.id].Content = field_option.id.split('/').splice(-1)[0]; field.value = false;" 
                        >
                            <span v-html="field_option.label" ></span>
                        </a>
                    </div>              
                </div>              
            </div>              

            <div class="radio" v-if="field.type === 'radio'" v-for="(field_option, field_optkey) in field.value"  v-bind:key="field_optkey">
                <label v-html="$root.t(field_option)"></label>
                <input v-model="form_data[field.id].Content" type="radio" :name="`wf[${field.id}]`" :value="field_option"/>
            </div>
            
            <div class="radio" v-if="field.type === 'checkbox'">
                <label v-html="$root.t(field.value)"></label>
                <input v-model="form_data[field.id].Content" type="checkbox" :name="`wf[${field.id}]`"/>
            </div>
        
        </div>
    </div>          
</template>

<script>

import _ from 'lodash'
import Vue from 'vue'
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
import {TheMask} from 'vue-the-mask'
 

export default {
  name: 'ProfileFormField',
  props: ['values', 'data', 'form_data'],
  components: {
      TheMask
  },
  data () {
      return {
          d: this.data,
          help: false
      }
  },
  methods: {
    intersection(a,b) {
        return _.intersection(a, b).length > 0 ? true : false
    },
    autocomplete_gnd(model, event) {
        this.$jsonp('https://lobid.org/gnd/search', {
            q : event.target.value,
            format : "json:preferredName,professionOrOccupation,dateOfBirth,placeOfBirth"
        }).then(json => {
            model.value = json;
        }).catch(err => {
            console.warn(err)
        })
    },
    remove(table, row) {
        table.splice(row, 1);
    },
    add(table, cellcount) {
        let _newrow = [];
        for (let index = 0; index < cellcount; index++) {
            _newrow[index] = "";
        }
        table.push(_newrow);
    },
    onFileChange(e, model) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
        if (['image/png','image/jpg','image/jpeg','image/gif'].indexOf(files[0].type) == -1) {
            alert(this.$root.t('upload:filetype'))
            this.$refs[`field_${model}`][0].value = "";
            return;
        }
        if (files[0].size > 250000) {
            alert(this.$root.t('upload:filesize'))
            this.$refs[`field_${model}`][0].value = "";
            return;
        }
        this.form_data[model].fileElement = files[0];
        this.form_data[model].htmlElement = e.target;
        this.$emit('update:model', this.form_data)
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .upload-preview {
        width: 100px;
        height: 100px;
        position: relative;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        a {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            float: none !important;
        }
    }

</style>



      